<ng-container *ngIf="_controlTemplate?.settings?.value; else noValue">
    <div class="flex border-b border-solid border-gray-300 last:border-b-0" *ngIf="showPictures() && !archived">
        <app-file-gallery-display [files]="files" [thumbnailSize]="56" class="w-full"></app-file-gallery-display>
    </div>
    <div class="border-b border-solid border-gray-300 last:border-b-0 italic font-light" *ngIf="archived">
        Archiviert
    </div>
    <div class="border-b border-solid border-gray-300 last:border-b-0" *ngIf="showNoPicturesPossible()">
        {{this._controlTemplate?.settings?.noPicturesPossibleLabel}}: {{_controlTemplate?.settings?.value?.picturesNotPossibleReason ? _controlTemplate?.settings?.value?.picturesNotPossibleReason : '-'}}
    </div>
</ng-container>
<ng-template #noValue>
    -
</ng-template>